<template>
  <div class="app-wrapper" :class="{'app-side-shrink':!sidebar.opened}">
    <div class="app-layout-admin" >
      <WtHeader/>
      <WtSide/>
      <WtBreadcrumb />
      <!-- <WtTabs/> -->
      <div class="app-body">
        <section class="app-main">
          <router-view :key="$route.path"></router-view>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import WtHeader from '@/components/WtLayout/WtHeader'
import WtSide from '@/components/WtLayout/WtSide'
import WtTabs from '@/components/WtLayout/WtTabs'
import WtBreadcrumb from '@/components/WtLayout/WtBreadcrumb.vue'
export default {
  name: 'layout',
  components: {
    WtHeader,
    WtTabs,
    WtSide,
    WtBreadcrumb
  },
  methods: {
    isCache(routeId) {
      console.log('this.cachedViews', this.cachedViews)
      if (this.cachedViews) {
        return (this.cachedViews.indexOf(routeId) !== -1)
      }
      return false
    }
  },
  computed: {
    ...mapState({
      cachedViews: state => state.wtTabs.cachedViews
    }),
    ...mapGetters([
      'sidebar'
    ])
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
